import { VisitorActionTypes } from './visitor.types'

//Add Visitor
export const addVisitorRecordRequest = (data) => ({
    type: VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST,
    payload: data
})

export const addVisitorRecordRequestSuccess = (data) => ({
    type: VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST_SUCCESS,
    payload: data
})

export const addVisitorRecordRequestError = (data) => ({
    type: VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST_ERROR,
    payload: data
})

export const addVisitorRecordRequestStatus = (data) => ({
    type: VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST_STATUS,
    payload: data
})

//Visitor List
export const visitorListRequest = (data) => ({
    type: VisitorActionTypes.VISITOR_LIST_REQUEST,
    payload: data
})

export const visitorListRequestSuccess = (data) => ({
    type: VisitorActionTypes.VISITOR_LIST_REQUEST_SUCCESS,
    payload: data
})

export const visitorListRequestError = (data) => ({
    type: VisitorActionTypes.VISITOR_LIST_REQUEST_ERROR,
    payload: data
})

//Visitor Exit
export const visitorExitRequest = (data) => ({
    type: VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST,
    payload: data
})

export const visitorExitRequestSuccess = (data) => ({
    type: VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST_SUCCESS,
    payload: data
})

export const visitorExitRequestError = (data) => ({
    type: VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST_ERROR,
    payload: data
})

export const visitorExitRequestStatus = (data) => ({
    type: VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST_STATUS,
    payload: data
})

//Update Visitor configuration
export const updateVisitorConfigurationRequest = (data) => ({
    type: VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST,
    payload: data
})

export const updateVisitorConfigurationRequestSuccess = (data) => ({
    type: VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST_SUCCESS,
    payload: data
})

export const updateVisitorConfigurationRequestError = (data) => ({
    type: VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST_ERROR,
    payload: data
})

export const updateVisitorConfigurationRequestStatus = (data) => ({
    type: VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST_STATUS,
    payload: data
})

//Get Visitor Configuration
export const getVisitorConfigurationRequest = (data) => ({
    type: VisitorActionTypes.VISITOR_GET_CONFIGURATION_REQUEST,
    payload: data
})

export const getVisitorConfigurationRequestSuccess = (data) => ({
    type: VisitorActionTypes.VISITOR_GET_CONFIGURATION_REQUEST_SUCCESS,
    payload: data
})

export const getVisitorConfigurationRequestError = (data) => ({
    type: VisitorActionTypes.VISITOR_GET_CONFIGURATION_REQUEST_ERROR,
    payload: data
})